import Vue from "vue"
import store from "../store"

// export const courseId = "60878cba7f0bed471ca2ab34" // dev
// export const courseId = "608b6f806a4a0864ca111e5f" // prod
export const formKey = "kct-tp"

/**
 * 
 * @returns {Promise<*>}
 */
export const getPreviewReport = (courseId) => {
    return Vue.axios.get(`${store.state.firebaseDomain}/evaluate/report/${courseId}/preview?report=identity`)
}

export const checkCompany = (formKey) => {
    return getFormByKey(formKey).then((form) => {
        if (form == null) return false
        else return true
    })
}

export const getDefaultForm = () => {
    return Vue.axios.get(`${store.state.api}/evaluate/form/default`).then((resp) => {
        return resp.data
    }).catch(() => {
        return null
    })
}

export const getFormByKey = (key) => {
    return Vue.axios.get(`${store.state.api}/evaluate/form/key/${key}`).then((resp) => {
        return resp.data
    }).catch(() => {
        return null
    })
}

export default { getPreviewReport, checkCompany, getDefaultForm, getFormByKey }